import React, { useState, useEffect } from "react";
import "./AdminPackage.css";

function Summarydetails(props) {
  const [summaryTabData, seSummaryTabData] = useState(props.summaryTabData);

  return (
    <div className="summaryWrapper">
      <div className="summaryContainer">
        <div className="summaryDetailsWrapper">
          <div className="summaryCardWrapper">
            <div className="summaryHeadingWrapper">
              <div className="font18 latoBlack">
                Summary<span className="latoRegular"> Details</span>
              </div>
            </div>
            {summaryTabData.length > 0 &&
              summaryTabData.map((tab, index) => (
                <div className="bodyWrapper">
                  <div className="dayWrapper">
                    <div className="font14 latoBlack darkText">
                      Day {index + 1}
                    </div>
                    <div className="font11">{tab?.label}</div>
                  </div>

                  <div>{tab?.content}</div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Summarydetails;
